import { useVhcStore } from 'features/vhc/model/vhc-store';
import { useState } from 'react';
import { Button, Modal } from 'react-bootstrap';

export const VhcConfirmationModal = () => {
  const [isLoading, setIsLoading] = useState(false);

  const { confirmationModalIsOpen, resetConfirmationModalData, confirmationModalData } = useVhcStore();

  const { title, message, confirmButtonText, cancelButtonText, onConfirm } = confirmationModalData || {};

  const handleConfirm = async () => {
    try {
      setIsLoading(true);
      await onConfirm?.();
      resetConfirmationModalData();
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal
      show={confirmationModalIsOpen}
      onHide={resetConfirmationModalData}
      centered
      backdrop="static"
      keyboard={false}
      size="sm"
    >
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body className="py-8">{message}</Modal.Body>
      <Modal.Footer>
        <Button variant="light-danger" onClick={resetConfirmationModalData} disabled={isLoading}>
          {cancelButtonText}
        </Button>
        <Button variant="danger" onClick={handleConfirm} disabled={isLoading}>
          {isLoading ? 'Loading...' : confirmButtonText}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
